import { render, staticRenderFns } from "./testResult.vue?vue&type=template&id=766f65de&scoped=true&"
import script from "./testResult.vue?vue&type=script&lang=js&"
export * from "./testResult.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "766f65de",
  null
  
)

export default component.exports